import type { ListPaymentInstruments } from '@cloudFunctions/types/payments/listPaymentInstruments';
import type { BackendRouteDefinition } from '../types';

/**
 * Migrated to `api-core-node` in PRA-776 (Phase 5 Sub-phase 1). The
 * cloudFunctions callable was retired in S9-WB2 (PRA-804); the type-only
 * `ListPaymentInstruments` namespace at the import path above remains the
 * canonical wire contract.
 */
export const listPaymentInstrumentsRoute = {
  transport: 'api',
  method: 'POST',
  path: '/admin/finix/payment-instruments:lookup',
  body: (requestData: ListPaymentInstruments.RequestData) => requestData,
} as const satisfies BackendRouteDefinition;
